import { AxiosPromise, AxiosResponse } from 'axios';
import {
    ChannelEvent,
    CompressionFormat,
    DeliveryLogType,
    ExportFileFormats,
    LinksClicked,
    Log,
    StatusMessageCategory,
} from '@dev/ee-api/ee-api-models';
import { EventLogParams, EventLogParamsByChannelName, LogParams } from '../../store/reports/types';

import { SingleContactPaginationInterface } from '../../store/contacts/types';
import { request } from './request';

export const loadLog = (params: LogParams): AxiosPromise<Log> => {
    const { Reports } = request();
    return Reports.reportsGet(
        params.statuses,
        params.messageCategory,
        params.from,
        params.to,
        params.channelName,
        params.limit,
        params.offset,
        params.includeEmail,
        params.includeSMS,
        params.email,
        params.ipaddress
    ).then((resp): AxiosResponse<Log> => resp);
};

export const loadEventLog = (params: EventLogParams): AxiosPromise<Log> => {
    const { Reports } = request();
    return Reports.reportsEventlogGet(
        params.statuses,
        params.messageCategory,
        params.from,
        params.to,
        params.channelName,
        params.limit,
        // params.offset,
        params.includeEmail,
        params.includeSMS,
        params.email,
        params.ipaddress
    );
};

export const loadEventLogByChannelName = (params: EventLogParamsByChannelName): AxiosPromise<ChannelEvent[]> => {
    const { Reports } = request();

    return Reports.reportsEventsByChannelnameGet(
        params.channelName,
        params.statuses,
        params.messageCategory,
        params.from,
        params.to,
        params.email,
        params.lastEvent,
        params.limit,
        params.offset,
        params.useMessageCategoryTypeInHeaders
    );
};

export const loadContactLinks = (params: SingleContactPaginationInterface): AxiosPromise<any[]> => {
    const { Reports } = request();
    return Reports.reportsLinktrackingsContactsByEmailGet(params.email, params.limit, params.offset).then(
        (resp): AxiosResponse<LinksClicked[]> => resp
    );
};

export const loadEventLogsByChannelNameCounts = (params: EventLogParamsByChannelName): AxiosPromise<void> => {
    const { Reports } = request();

    return Reports.reportsEventsByChannelnameCountsGet(
        params.channelName,
        params.from,
        params.to,
        params.email,
        params.lastEvent,
        params.useMessageCategoryTypeInHeaders
    );
};

export type ExportLogsParams = {
    statuses: DeliveryLogType[];
    fileFormat?: ExportFileFormats;
    from?: string;
    to?: string;
    channelName?: string;
    limit?: number;
    offset?: number;
    includeEmail?: boolean;
    includeSms?: boolean;
    messageCategory?: StatusMessageCategory[];
    compressionFormat?: CompressionFormat;
    fileName?: string;
    email?: string;
    onlyLastEvent?: boolean;
    isNotification?: boolean;
};

export interface LogsParams {
    statuses?: DeliveryLogType[];
    messageCategory?: StatusMessageCategory[];
    from?: string;
    to?: string;
    channelName?: string;
    limit?: number;
    offset?: number;
    includeEmail?: boolean;
    includeSms?: boolean;
    email?: string;
    ipaddress?: string;
}
